import { Chip, ChipProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { InvoiceStatus } from '../../api/gql';
import { getInvoiceStateProperties } from '../../utils/invoice';

type InvoiceStateTextProps = {
  state: InvoiceStatus;
} & Omit<ChipProps, 'children'>;
export const InvoiceStateBadge = ({ state, ...rest }: InvoiceStateTextProps) => {
  const { t } = useTranslation();
  const { transKey, color } = getInvoiceStateProperties(state, '');
  return <Chip variant={'outlined'} label={t(transKey)} sx={{ borderColor: color, color: color }} {...rest} />;
};
